import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import { Icon } from "@iconify/react";
//Componentes
const Redimir = lazy(() => import("./redimir"))
const CodigoCrearCuenta = lazy(() => import("./crear-cuenta/crear-cuenta"))
const CodigoFinal = lazy(() => import("./codigo-final"))

/**
 * Componente principal para la sección de código.
 *
 * @component
 * @param {object} props - Propiedades del componente.
 * @returns {JSX.Element} El elemento JSX que representa la sección de código.
 */
const Codigo = (props) => {
  const { textosSubSecciones: textos } = useObtenerSubsecciones('seccion_codigo');


  return (
    <>
      <section className="main-container mm-redimir ">
        <div className="container main-content px-3 px-lg-5">
          <ol className="onbackground-primary--color mm-redimir_steps p-0 my-5 mx-0 row justify-content-between align-items-center">
            <li>
              <div className="cont-paso">
                <p className="text-center">
                  <span className={`step mr-2 ${props.match.params.section === 'redimir' ? 'step-active' : ''}`}>1</span>
                  {textos?.header?.pasos?.paso_1 || 'Ingresar código'}
                </p>
              </div>
              <hr />
            </li>
            <li>
              <div className="cont-paso">
                <p className=" text-center">
                  <span className={`step mr-2 ${props.match.params.section === 'crear-cuenta' ? 'step-active' : ''}`}>2</span>
                  {textos?.header?.pasos?.paso_2 || 'Crear cuenta'}
                </p>
              </div>
              <hr />
            </li>
            <li>
              <div className="cont-paso">
                <p className="  text-center">
                  <span className={`step mr-2 ${props.match.params.section === 'codigo-final' ? 'step-active' : ''}`}>3</span>
                  {textos?.header?.pasos?.paso_3 || 'Iniciar sesión'}
                </p>
              </div>
            </li>
          </ol>


          <div className="contenedor-altura-minima w-100">
            <Suspense
              fallback={
                <div className="row d-flex justify-content-center secondary-inverse--color" style={{ minHeight: '800px', minWidth: '100%' }}>
                  <Icon icon="icomoon-free:spinner9" className={'icon spinner-rotation'} width={70} height={70} />
                </div>
              }
            >
              <Switch>
                <Route exact path='/codigo/redimir' render={() => <Redimir />} />
                <Route exact path='/codigo/crear-cuenta' render={() => <CodigoCrearCuenta />} />
                <Route exact path='/codigo/codigo-final' render={() => <CodigoFinal />} />
              </Switch>
            </Suspense>
          </div>
        </div>
      </section>
    </>
  )

}
export default Codigo;